var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      !_vm.disabled
        ? _c("vxe-toolbar", {
            scopedSlots: _vm._u(
              [
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _c(
                        "vxe-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.addTable()
                            },
                          },
                        },
                        [_vm._v("选择供货关系")]
                      ),
                      _c(
                        "vxe-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.deleteTable()
                            },
                          },
                        },
                        [_vm._v("清空")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3733388591
            ),
          })
        : _vm._e(),
      _c(
        "vxe-table",
        {
          ref: "fineTable",
          attrs: { "show-overflow": "", data: _vm.tableList, height: "300px" },
        },
        [
          _c("vxe-table-column", {
            attrs: { field: "terminalCode", title: "终端编码" },
          }),
          _c("vxe-table-column", {
            attrs: { field: "terminalName", title: "终端名称" },
          }),
          _vm.type === "update"
            ? _c("vxe-table-column", {
                attrs: { field: "dealerName", title: "经销商" },
              })
            : _vm._e(),
          _vm.type === "update"
            ? _c("vxe-table-column", {
                attrs: { field: "productName", title: "产品" },
              })
            : _vm._e(),
          _vm.type === "update"
            ? _c("vxe-table-column", {
                attrs: { field: "salesmanName", title: "业务员" },
              })
            : _vm._e(),
          _vm.type === "update"
            ? _c("vxe-table-column", {
                attrs: { field: "positionName", title: "职位" },
              })
            : _vm._e(),
          _vm.type === "add"
            ? _c("vxe-table-column", {
                attrs: { field: "provinceName", title: "省" },
              })
            : _vm._e(),
          _vm.type === "add"
            ? _c("vxe-table-column", {
                attrs: { field: "cityName", title: "市" },
              })
            : _vm._e(),
          _vm.type === "add"
            ? _c("vxe-table-column", {
                attrs: { field: "districtName", title: "区" },
              })
            : _vm._e(),
          !_vm.disabled
            ? _c("vxe-column", {
                attrs: { title: "操作", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletRow(row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  239364282
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }